import Select from "@rio-cloud/rio-uikit/Select";
import "./styles.css";
import { ScheduleViewType } from "../..";
import SearchAutocomplete from "../../../../../../components/form/searchAutocomplete";
import { ServiceBaySchedule } from "../../../../../../models/serviceBay";
import { useMediaQuery } from "@mui/material";

interface ICalendarTitleProps {
  currentDate: Date;
  firstWeekDay: Date;
  lastWeekDay: Date;
  handleScheduleSidebar: () => void;
  scheduleViewType: ScheduleViewType;
  setScheduleViewType: (scheduleViewType: ScheduleViewType) => void;
  onCreateSchedule: () => void;
  consultantMonthSchedule: ServiceBaySchedule[];
  goToDate: (date: Date) => void;
  openScheduleModal: (schedule: ServiceBaySchedule) => void;
}

const Title = ({
  currentDate,
  firstWeekDay,
  lastWeekDay,
  scheduleViewType,
  handleScheduleSidebar,
  setScheduleViewType,
  onCreateSchedule,
  consultantMonthSchedule,
  goToDate,
  openScheduleModal
}: ICalendarTitleProps) => {

  const isResponsiveView = useMediaQuery("(max-width: 1024px)");

  const getFormatedFirstWeekDay = () => {
    if (firstWeekDay.getMonth() !== lastWeekDay.getMonth()) {
      return firstWeekDay
        .toLocaleDateString("pt-BR", { day: "2-digit", month: "long" })
        .replace(/ de /g, " ");
    } else {
      return firstWeekDay.toLocaleDateString("pt-BR", { day: "2-digit" });
    }
  };

  const renderFirstWeekFullYear = () => {
    return (
      <span className="text-normal">
        {firstWeekDay.getFullYear() !== lastWeekDay.getFullYear()
          ? firstWeekDay.getFullYear()
          : ""}
      </span>
    );
  };

  return (
    <div
      className={`${isResponsiveView ? 'mobile-calendar-header' : 'height-80'} width-100pct ${isResponsiveView ? 'display-flex flex-direction-column' : 'display-grid gap-20 grid-cols-2-1fr-auto'}`}
      style={{ borderBottomWidth: 1 }}
    >
      <div className={`display-flex align-items-center ${isResponsiveView ? 'mobile-date-row padding-10' : ''}`}>
        <span
          className="rioglyph rioglyph-th-list padding-15 text-size-20 cursor-pointer"
          onClick={handleScheduleSidebar}
        />
        <div className="display-flex align-items-center" style={{ width: isResponsiveView ? '100%' : 'auto' }}>
          {scheduleViewType === "month" && (
            <span className={`text-medium text-capitalize week-calendar-title ${isResponsiveView ? 'mobile-title' : 'padding-15'}`}>
              {currentDate.toLocaleDateString("pt-BR", { month: "long" })}{" "}
              <span className="text-normal">{lastWeekDay.getFullYear()}</span>
            </span>
          )}

          {scheduleViewType === "week" && (
            <span className={`text-medium text-capitalize week-calendar-title ${isResponsiveView ? 'mobile-title' : 'padding-15'}`}>
              {getFormatedFirstWeekDay()}
              {renderFirstWeekFullYear()}-
              {lastWeekDay
                .toLocaleDateString("pt-BR", { day: "2-digit", month: "long" })
                .replace(/ de /g, " ")}{" "}
              <span className="text-normal">{lastWeekDay.getFullYear()}</span>
            </span>
          )}

          {scheduleViewType === "day" && (
            <span className={`text-medium text-capitalize week-calendar-title ${isResponsiveView ? 'mobile-title' : 'padding-15'}`}>
              <span className="text-normal">
                {currentDate.toLocaleDateString("pt-BR", { weekday: "long" })},{" "}
              </span>
              {currentDate
                .toLocaleDateString("pt-BR", { day: "2-digit", month: "long" })
                .replace(/ de /g, " ")}
              <span className="text-normal"> {currentDate.getFullYear()}</span>
            </span>
          )}
        </div>
        {!isResponsiveView && (
          <div className="padding-10">
            <Select
              placeholder="Tipo de cronograma"
              options={[
                { id: "month", label: "Mês" },
                { id: "week", label: "Semana" },
                { id: "day", label: "Dia" },
              ]}
              onChange={(item) => setScheduleViewType(item!.id as ScheduleViewType)}
              btnClassName="btn btn-primary btn-outline"
              value={[scheduleViewType]}
            />
          </div>
        )}
        {isResponsiveView && (
          <div className="display-flex align-items-center padding-10 gap-10">
            <Select
              placeholder='Tipo de cronograma'
              options={[
                { id: 'month', label: 'Mês' },
                { id: 'week', label: 'Semana' },
                { id: 'day', label: 'Dia' }
              ]}
              onChange={item => setScheduleViewType(item!.id as ScheduleViewType)}
              btnClassName='btn btn-primary btn-outline mobile-select'
              value={[scheduleViewType]}
            />
            <button
              type="button"
              className="btn bg-highlight-darker mobile-create-btn ml-4"
              onClick={onCreateSchedule}
            >
              <span className="text-capitalize">Criar</span>
              <span className="rioglyph rioglyph-plus-sign" aria-hidden="true" />
            </button>
          </div>
        )}
        <div className={`${isResponsiveView ? 'w-full mt-2' : 'w-[300px] ml-4'}`}>
          <SearchAutocomplete
            id="5"
            placeholder="Busque por chassi"
            fetchOptions={async (searchTerm: string) => {
              return consultantMonthSchedule
                .filter((schedule) => schedule.occurrence?.vehicleChassis?.includes(searchTerm))
                .map((schedule) => ({
                  vehicleChassis: schedule.occurrence?.vehicleChassis,
                  box: schedule.serviceBay?.name,
                  schedule: schedule
                }));
            }}
            optionLabel={{
              vehicleChassis: 'Chassi',
              box: 'Box',
            }}
            onSelectedOption={(e) => {
              if (e.schedule?.startDate) {
                goToDate(e.schedule?.startDate);
              }
              if (e.schedule) {
                openScheduleModal(e.schedule);
              }
            }}
            overlay
            overlayClassName="!w-[300px]"
          />
        </div>
      </div>
      {!isResponsiveView && (
      <div className="display-flex align-items-center padding-20">
        <button
          type="button"
          className="btn bg-highlight-darker padding-7"
          onClick={onCreateSchedule}
        >
          <span className="text-capitalize padding-right-5">
            Criar agendamento
          </span>
          <span className="rioglyph rioglyph-plus-sign" aria-hidden="true" />
        </button>
      </div>
      )}
    </div>
  );
};

export default Title;
